<template>
  <label
    class="glass-toggle"
    :class="{
      'glass-toggle--checked': modelValue,
      'glass-toggle--disabled': disabled,
      'glass-toggle--focused': isFocused,
    }"
  >
    <input
      :id="resolvedInputId"
      type="checkbox"
      class="glass-toggle__input"
      :checked="modelValue"
      :disabled="disabled"
      :aria-label="ariaLabel"
      @change="onChange"
      @focus="isFocused = true"
      @blur="isFocused = false"
    />
    <span class="glass-toggle__track" aria-hidden="true">
      <span class="glass-toggle__thumb"></span>
    </span>
  </label>
</template>

<script>
let glassToggleInstanceCounter = 0;

export default {
  name: 'GlassToggle',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      default: '',
    },
    ariaLabel: {
      type: String,
      default: 'Toggle',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      isFocused: false,
      instanceId: `glass-toggle-${++glassToggleInstanceCounter}`,
    };
  },
  computed: {
    resolvedInputId() {
      return this.inputId || this.instanceId;
    },
  },
  methods: {
    onChange(event) {
      const checked = event.target.checked;
      this.$emit('update:modelValue', checked);
      this.$emit('change', checked);
    },
  },
};
</script>

<style src="./GlassToggle.css"></style>
